import React, { useCallback, useState } from 'react'
import { isIterableArray } from '../../../utils/utils'
import DoughnutGraph from './DoughnutGraph'
import { useTranslation } from 'react-i18next'
import { Typography } from '@material-tailwind/react'
import { doughnutColors } from '../../../utils/variables'

const DoughnutGraphController = ({ currentData, graphTarifId, graphPriceId }: { currentData: any, graphTarifId: string, graphPriceId: string }) => {

    const { t } = useTranslation()

    const KEYVAL1 = 'price'
    const KEYVAL2 = 'total_for_act'

    const unique = Object.keys(currentData).map(i => {
        return ({
            key: i,
            show: true,
            price: currentData[i].price,
            total_for_act: currentData[i].total_for_act
        })
    })
    const [legend, setLegend] = useState(unique);
    const formatted = useCallback(
        () => {
            if (currentData) {
                // console.log('WPK useCallback')

                return isIterableArray(Object.keys(currentData)) ?
                    Object.keys(currentData).reduce((acc: any, key: any) => {

                        const isshow = legend.find(i => i.key === key)
                        if (!isshow?.show) return acc

                        const item = currentData[key]
                        if (item?.[KEYVAL1]) {
                            acc.values1.push(item?.[KEYVAL1])
                            acc.labels1.push(key)
                            acc.colors1.push(doughnutColors[key])
                        }
                        if (item?.[KEYVAL2]) {
                            acc.values2.push(item?.[KEYVAL2])
                            acc.labels2.push(key)
                            acc.colors2.push(doughnutColors[key])
                        }
                        return acc
                    }, {
                        values1: [],
                        labels1: [],
                        values2: [],
                        labels2: [],
                        colors1: [],
                        colors2: []
                    })
                    :
                    false
            }
        },
        [currentData, legend]
    )


    const computedColors = useCallback(
        () => {
            if (currentData) {
                return isIterableArray(Object.keys(currentData)) ?
                    Object.keys(currentData).reduce((acc: any, key: any) => {

                        const isshow = legend.find(i => i.key === key)
                        if (!isshow?.show) return acc

                        const item = doughnutColors[key]

                        acc.push(item)

                        return acc
                    }, [])
                    :
                    false
            }
        },
        [doughnutColors, legend]
    )

    return (
        <div>
            {/* currentData.month && */}
            <DoughnutGraph
                currentData={formatted()}
                graphTarifId={graphTarifId}
                graphPriceId={graphPriceId}
            >
                <div className='my-[16px] flex gap-[8px] lap:gap-[4px] flex-wrap justify-center'>
                    {
                        isIterableArray(unique) &&
                        legend.map((item, index) => (
                            <div key={index} className='flex gap-[2px] items-center cursor-pointer' onClick={() => {
                                setLegend(prev => prev.map(i => ({
                                    ...i,
                                    show: item.key === i.key ? !i.show : i.show
                                })))
                            }}>
                                <span className={`block rounded w-[10px] h-[10px]  `} style={{ backgroundColor: item.show ? doughnutColors?.[item.key] : '#eee' }}></span>
                                <Typography variant='lead' className={`${item.show ? 'text-gray-700' : 'text-gray-400'}  font-medium text-[12px] lap:text-[14px]`}>
                                    {t(`analytics.pie_${item.key}`)}
                                </Typography>
                            </div>
                        ))
                    }
                </div>
            </DoughnutGraph>

        </div >
    )
}

export default DoughnutGraphController